import { SwapContainer } from '../containers/SwapContainer'
import { useEthersFromWagmi } from '../hooks/useEthersFromWagmi'

export function SwapPage() {
  const { provider, signer, address, chainId } = useEthersFromWagmi()
  return (
    <div className="mx-auto w-full max-w-2xl">
      <SwapContainer signer={signer} provider={provider} address={address} chainId={chainId} />
    </div>
  )
}
